var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-pages"},[_c('PageTitle',{attrs:{"imagem":"cadastrarusuarios.png","main":_vm.$t('gestao-de-usuarios-0'),"sub":_vm.$t('insercao-e-ou-alteracoes')}}),_c('div',{staticClass:"-pagesadmin-tabs"},[_c('UserAdmin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }